import { request } from "./Request"

export const getSession = async () => {
    return await request('/api/auth/me',{
        noRedirect:true
    })
}